import api from './api';

export const listStorefrontAuthProfiles = async () => (await api.get('/storefront-auth-profiles')).data;
export const getStorefrontAuthProfile = async (storefront) => (await api.get(`/storefront-auth-profiles/${encodeURIComponent(storefront)}`)).data;
export const saveStorefrontAuthProfile = async (storefrontId, payload) => (await api.put(`/storefront-auth-profiles/${storefrontId}`, payload)).data;
